import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { navigationLinks, businessInfo } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white border-b border-border sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex flex-col">
            <span className="font-heading text-2xl font-medium text-foreground">
              {businessInfo.name}
            </span>
            <span className="uppercase !text-xs text-muted-foreground">Amma Assis en entreprise

            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navigationLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-body font-normal transition-smooth link-underline ${
              isActive(link.path) ?
              'text-primary' :
              'text-foreground hover:text-primary'}`
              }>

                {link.name}
              </Link>
            )}
          </nav>

          {/* Contact Button - Desktop */}
          <div className="hidden lg:flex items-center gap-6">
            <a
              href="tel:+33600000000"
              className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-smooth">

              <Phone className="w-4 h-4" />
              <span>{businessInfo.phone}</span>
            </a>
            <Link
              to="/contact"
              className="btn-primary">

              Demander un devis
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-foreground hover:text-primary transition-smooth"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}>

            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen &&
        <div className="lg:hidden border-t border-border py-6">
            <nav className="flex flex-col gap-4">
              {navigationLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              className={`text-base font-body py-2 transition-smooth ${
              isActive(link.path) ?
              'text-primary' :
              'text-foreground hover:text-primary'}`
              }
              onClick={() => setIsMenuOpen(false)}>

                  {link.name}
                </Link>
            )}
              <div className="pt-4 mt-4 border-t border-border">
                <Link
                to="/contact"
                className="btn-primary w-full text-center"
                onClick={() => setIsMenuOpen(false)}>

                  Demander un devis
                </Link>
              </div>
            </nav>
          </div>
        }
      </div>
    </header>);

};

export default Header;